var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-4" }, [
    _c(
      "div",
      {
        staticClass: "col col-12 col-md-4 col-lg-6 colorsample-cartitem-color",
      },
      [
        _c("div", {
          staticClass: "color-block",
          style: {
            background:
              _vm.color.hex && _vm.color.hex.length > 0
                ? (_vm.color.hex.substring(0, 1) != "#" ? "#" : "") +
                  _vm.color.hex
                : "url(" + _vm.color.image + ")",
          },
        }),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "col col-6 col-md-3 col-lg-2 colorsample-cartitem-details",
      },
      [
        _c("div", { staticClass: "color-code-buttons-container" }, [
          _c(
            "a",
            {
              staticClass: "actionToggleDashboard color-code-button",
              attrs: { href: "#" },
            },
            [
              _c(
                "i",
                {
                  staticClass:
                    "actionToggleDashboard\n             material-icons ",
                  attrs: {
                    "data-card-id": _vm.color.card.id,
                    "data-add-url": "/myBaumit/ajaxAddCardToDashboard",
                    "data-delete-url": "/myBaumit/ajaxDeleteCardFromDashboard",
                    "data-added-to-dashboard": "0",
                  },
                },
                [_vm._v("star_border")]
              ),
            ]
          ),
          _c(
            "a",
            {
              staticClass: "color-code-button",
              attrs: { href: "#" },
              on: { click: _vm.remove },
            },
            [_c("delete-s-v-g", { staticClass: "svg-icon" })],
            1
          ),
        ]),
        _c("span", { staticClass: "color-code-title" }, [
          _vm._v(_vm._s(_vm.trans("products_color_code"))),
        ]),
        _c("br"),
        _c("span", { staticClass: "color-code" }, [
          _vm._v(_vm._s(_vm.color.name)),
        ]),
        _c("p", { staticClass: "color-details" }, [
          _vm.color.hex
            ? _c("span", [_vm._v("HEX: " + _vm._s(_vm.color.hex))])
            : _vm._e(),
          _c("br"),
          _vm.color.rgb_r
            ? _c("span", [
                _vm._v(
                  "RGB: " +
                    _vm._s(
                      _vm.color.rgb_r +
                        "/" +
                        _vm.color.rgb_g +
                        "/" +
                        _vm.color.rgb_b
                    )
                ),
              ])
            : _vm._e(),
          _c("br"),
          _vm.color.hbw
            ? _c("span", [_vm._v("HBW: " + _vm._s(_vm.color.hbw))])
            : _vm._e(),
          _c("br"),
        ]),
      ]
    ),
    _c(
      "div",
      {
        staticClass:
          "col col-6 col-md-5 col-lg-4 colorsample-cartitem-functions",
      },
      [
        _c("div", { staticClass: "color-order" }, [
          _c("div", { staticClass: "color-order-row" }, [
            _c("span", { staticClass: "mr-2 color-order-row-label" }, [
              _vm._v(_vm._s(_vm.trans("sample_order_unit_price")) + ": "),
            ]),
            _c("span", { staticClass: "color-order-row-value" }, [
              _vm._v(
                _vm._s(
                  _vm.currency +
                    " " +
                    _vm.myPpriceFormat(_vm.getUnitPriceWithVat)
                )
              ),
            ]),
          ]),
          false
            ? _c(
                "div",
                { staticClass: "color-order-row color-order-row-last-row" },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "color-order-subtotal mr-2 color-order-row-label",
                    },
                    [_vm._v(_vm._s(_vm.trans("sample_order_subtotal")) + ": ")]
                  ),
                  _c("span", { staticClass: "color-order-row-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.currency + " " + _vm.myPpriceFormat(_vm.getSubtotal)
                      )
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "color-order-row" }, [
            _c("span", { staticClass: "mr-2 color-order-row-label" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.trans("sample_order_quantity"))),
              ]),
              _vm._v(": "),
            ]),
            _c(
              "div",
              { staticClass: "color-order-button-wrapper" },
              [
                _c("span", { class: _vm.canModifyQuantity ? "mr-2" : "" }, [
                  _vm._v(_vm._s(_vm.quantity)),
                ]),
                _vm.canModifyQuantity
                  ? [
                      _c("i", {
                        class: _vm.getButtonClass("fa-plus"),
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.increase },
                      }),
                      false ? _c("span", [_vm._v("/")]) : _vm._e(),
                      _c("i", {
                        class: _vm.getButtonClass("fa-minus"),
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.decrease },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm.enableStructure
            ? _c("div", { staticClass: "color-order-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "color-order-structure-container",
                    style: {
                      background:
                        _vm.color.hex && _vm.color.hex.length > 0
                          ? (_vm.color.hex.substring(0, 1) != "#" ? "#" : "") +
                            _vm.color.hex
                          : "url(" + _vm.color.image + ")",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "color-order-structure-image-border" },
                      [
                        _c("div", {
                          staticClass: "color-order-structure-image",
                          style: {
                            backgroundImage:
                              "url(" + _vm.selectedStructureObject.image + ")",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "span",
                      { staticClass: "color-order-structure-select-label" },
                      [_vm._v(_vm._s(_vm.trans("sample_order_texture_code")))]
                    ),
                    _c("div", { staticClass: "color-order-structure-select" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-secondary dropdown-toggle-dropdown-order",
                          attrs: {
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false",
                          },
                        },
                        [_vm._v(" " + _vm._s(this.structure) + " ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "dropdown-menu" },
                        [
                          _vm._l(_vm.structures, function (item, key) {
                            return _c(
                              "button",
                              {
                                key: key,
                                staticClass: "dropdown-item",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeStructure(item)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(item.name) + " ")]
                            )
                          }),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _c("div", { staticClass: "color-order-row" }, [
            _vm.enableStructure
              ? _c("p", { staticClass: "color-order-structure-details" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.selectedStructureObject.cart_info_text) +
                      " "
                  ),
                ])
              : _c("p", {
                  staticClass: "color-order-structure-details",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.trans("sample_order_default_structure_info")
                    ),
                  },
                }),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }